import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { BootstrapService } from './bootstrap.service';
import { Injectable } from '@angular/core';

@Injectable()
export class BootstrapGuard implements CanActivate {

    constructor(private bootstrapService: BootstrapService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise((resolve) => {
            if (this.bootstrapService.booted) {
                resolve(true);
                return true;
            }

            this.bootstrapService.boot().subscribe(() => {
                resolve(true);
            }, (error) => {
                resolve(false);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/bootstrap/bootstrap.guard.ts